import {
  modalRightSlideInAnimation,
  modalRightSlideOutAnimation,
  modalSlideUpEnterAnimation,
  modalSlideUpLeaveAnimation
} from '@apps-common/lib/modal-animations'
import { useBelowBreakpoint } from './useBelowBreakpoint'

interface IProps {
  mobileCss?: string
  desktopCss?: string
}

export const useFilterModalAnimation = ({ mobileCss, desktopCss }: IProps) => {
  const isBelow = useBelowBreakpoint('md')

  return isBelow
    ? {
        enterAnimation: modalSlideUpEnterAnimation,
        leaveAnimation: modalSlideUpLeaveAnimation,
        css: mobileCss
      }
    : {
        enterAnimation: modalRightSlideInAnimation,
        leaveAnimation: modalRightSlideOutAnimation,
        css: desktopCss
      }
}
